import React from 'react';
import '../App.css';

const TranslationSelect = ({ onSelect }) => {
    const handleChange = (e) => {
        onSelect(e.target.value);
    };

    return (
        <div>
            <label htmlFor="translation">Choose a translation:</label>
            <select id="translation" onChange={handleChange}>
                <option value="">Select</option>
                <option value="kjv">KJV</option>
                <option value="niv">NIV</option>
            </select>
        </div>
    );
};

export default TranslationSelect;
